<script>
  // Standardized page header for every page type. Backward compatible with the
  // original {title, actions} API; adds subtitle, breadcrumbs, a back link, and
  // `badges`/`filters` snippet rows.
  //
  //   <PageHeader title="Quests" subtitle="Weekly capture challenges">
  //     {#snippet actions()}<Button icon="add" href="/quests/new">New quest</Button>{/snippet}
  //   </PageHeader>
  //
  //   <PageHeader title={user.name} back="/users" breadcrumbs={[{label:'Users',href:'/users'},{label:user.name}]}>
  //     {#snippet badges()}<Badge variant="success" soft>Active</Badge>{/snippet}
  //   </PageHeader>
  // List pages pass `count` (the filtered results: pagy.count or rows.length) and
  // `total` (the server's unfiltered `total_count`), shown as "146 of 175" while a
  // filter narrows the list.
  import Breadcrumbs from './breadcrumbs.svelte'
  import Button from './ui/button.svelte'

  let { title, subtitle = null, count = null, total = null, breadcrumbs = null, back = null, actions, filters, badges } = $props()
</script>

<div class="mb-6">
  {#if breadcrumbs}<Breadcrumbs items={breadcrumbs} />{/if}

  <div class="flex items-start justify-between gap-3 flex-wrap">
    <div class="flex items-start gap-3 min-w-0">
      {#if back}
        <Button variant="ghost" size="sm" square icon="back" href={back} aria-label="Back" class="mt-0.5" />
      {/if}
      <div class="min-w-0">
        <div class="flex items-center gap-2 flex-wrap">
          <h1 class="text-2xl font-bold truncate">{title}</h1>
          {#if count != null}<span class="badge badge-primary badge-soft font-semibold tabular-nums"><span>{count.toLocaleString()}{#if total != null && total !== count}&nbsp;<span class="font-normal opacity-70">of {total.toLocaleString()}</span>{/if}</span></span>{/if}
          {#if badges}{@render badges()}{/if}
        </div>
        {#if subtitle}<p class="text-base-content/60 text-sm mt-0.5">{subtitle}</p>{/if}
      </div>
    </div>

    {#if actions}
      <div class="flex items-center gap-2 flex-wrap">{@render actions()}</div>
    {/if}
  </div>

  {#if filters}<div class="mt-4">{@render filters()}</div>{/if}
</div>
